<template>
    <span v-tooltip="{ content: getText, html, trigger, delay, placement, container, popperOptions }" ref="container">
        <slot>
            <IconBase
              width="10"
              height="10"
              :iconColor="consts.COLORS.LIGHT_700"
              iconName="infoTooltipIcon"/>
        </slot>
    </span>
</template>

<script>
import IconBase from 'components/IconBase.vue';
import consts from 'services/metaData/consts';
import Vue from 'vue';
import tooltip from 'services/libWrappers/vue-tooltip';
import tooltipConsts from './consts';

tooltip(Vue);
// import tooltipStyle from 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';
// import componentStyle from '!to-string!css!./tooltip.css';

export default {
    name: 'Tooltip',
    props: {
        text: String,
        html: Boolean,
        delay: Number,
        visible: {
            type: Boolean,
            default: true
        },
        trigger: {
            type: String,
            default: 'hover'
        },
        forceShowWithTruncate: {
            type: Boolean,
            default: false
        },
        placement: {
            type: String,
            default: 'top',
            validator: (val) => tooltipConsts.TOOLTIP_POSITIONS.includes(val)
        },
        container: {
            type: [String, Boolean],
            default: 'body'
        },
        preventOverflow: {
            type: Boolean,
            default: undefined
        }
    },
    data() {
        return {
            isMounted: false,
            showTooltip: false,
            consts
        };
    },
    computed: {
        getText() {
            return this.showTooltip ? this.text : null;
        },
        popperOptions() {
            if (this.preventOverflow !== undefined) {
                return {
                    modifiers: {
                        preventOverflow: {
                            enabled: this.preventOverflow
                        },
                        hide: {
                            enabled: false
                        }
                    }
                };
            }
            return undefined;
        }
    },
    mounted() {
        this.isMounted = true;
        this.checkShouldShowTooltip();
    },
    methods: {
        async checkShouldShowTooltip() {
            // we wait for the next tick to make sure that the dom was updated after the text change
            await this.$nextTick();
            if (!this.forceShowWithTruncate) {
                const elem = this.$refs.container;
                const textOverflow = elem && window.getComputedStyle(elem, null)
                    .getPropertyValue('text-overflow');
                if (textOverflow === 'ellipsis') {
                    this.showTooltip = this.$refs.container.offsetWidth < this.$refs.container.scrollWidth;
                    return;
                }
            }

            this.showTooltip = true;
        }
    },
    watch: {
        text() {
            this.checkShouldShowTooltip();
        }
    },
    components: {
        IconBase
    }
};
</script>

<style lang="scss">
   @import './tooltip.css';

    .customTooltip {
        &.vue-tooltip {
            font-size: 12px;
            font-family: 'Open Sans';
            font-weight: normal;
            background-color: #112239;
            color: #FFF;
            border-radius: 3px;
            box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.1);
        }

        &.vue-tooltip .tooltip-arrow {
            border-color: #112239;
            color: #FFF;
        }
    }
</style>
